import React from "react";
import { Card, Col, Row } from "react-bootstrap";

const CharteredTrackDetails = (trackData, selOrder, setSelOrder) => {
  const openCharteredDetails = (type, data) => {
    const url = `/charteredOrderDetails?data=${data.orderId}`;
    window.open(url, "_blank");
  };
  return (
    <Card
      bg="Light"
      className={` mb-2 card-click ${
        selOrder?.wayBillNo === trackData?.wayBillNo && `card-click-box-shadow`
      }`}
      onClick={() => setSelOrder(trackData)}
    >
      <div class="border border-1 rounded bg-white p-2">
        <div class="row">
          <div class="col font-12 text-start">Waybill Number:</div>
          <div class="col theme-blue-txt text-end">{trackData?.wayBillNo}</div>
        </div>
        <div class="row">
          <div class="col font-12 text-start">Order Number:</div>
          <div
            class="col modal-links fw-bold text-end"
            onClick={() => openCharteredDetails("order", trackData)}
          >
            {trackData?.orderNo}
          </div>
        </div>
        {/* <div class="row">
          <div class="col font-12 text-start">Recipient Address:</div>
          <div class="col theme-blue-txt text-end">
            {trackData?.receipientAddress}
          </div>
        </div> */}
        <div class="row">
          <div class="col font-12 text-start">Last Location:</div>
          <div class="col theme-red-txt text-end">
            {trackData?.last_location}
          </div>
        </div>
        <div class="row">
          <div class="col font-12 text-start">Last Event:</div>
          <div class="col text-warning text-end">
            {trackData?.last_event_type_text}
          </div>
        </div>
        <div class="row">
          <div class="col font-12 text-start">Estimated Delivery:</div>
          <div class="col theme-blue-txt text-end">
            {trackData?.estDelivery}
          </div>
        </div>
        <div class="row">
          <div class="col font-12 text-start">Shipment Date:</div>
          <div class="col theme-blue-txt text-end">
            {trackData?.shipmentDate}
          </div>
        </div>
        <div class="row">
          <div class="col font-12 text-start">Status:</div>
          <div class="col theme-blue-txt text-end">{trackData?.status}</div>
        </div>
        <div class="clearfix"></div>
      </div>
    </Card>
  );
};

const CharteredTrackDetailsList = ({ trackData, selOrder, setSelOrder }) => {
  return (
    <div className="vh-100 overflow-auto">
      <div className="row m-1">
        {trackData?.map((shipment, index) => (
          <div
            className={`ps-1 pe-0 ${
              trackData?.length > 1 ? "col-md-6" : "col-md-12"
            }`}
          >
            {CharteredTrackDetails(shipment, selOrder, setSelOrder)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CharteredTrackDetailsList;
